import { connect } from "react-redux";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import AuthProvider from "../../auth/AuthProvider";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";
import React from "react";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";
import General from "./Tabs/General";

const endPoint = "core/timeschedule";

function TimescheduleForm(props) {
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"timeschedules"}>
      <VestigingProvider vestiging={vestiging}>
        <JamezzFormV2
          computedPageTitle={function (model) {
            return formatTitle(this.pageTitle, model.name);
          }}
          endPoint={endPoint}
          extraFields={extraFields}
          extraFormProps={{ vestiging, vestigingId: vestiging?.id }}
          onGetModel={onGetModel}
          pageTitle={getTranslation("timeschedules.form.pageTitle", "Timeschedule")}
          pageTitleSubject={
            <small>
              <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
            </small>
          }
          rootRight={"timeschedules"}
          parseOutput={{ opening_hours: (object) => JSON.stringify(object) }}
          tabs={[
            {
              right: "general",
              tabButton: <TranslationWrapper tDefault={"General"} tKey={"timeschedules.form.general"} />,
              tabContent: <General />,
            },
          ]}
        />
      </VestigingProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(TimescheduleForm);
